import { compose } from 'redux'
import { connect } from 'react-redux'

import { withTranslator } from '../../components/HOCComponents/withTranslator'
import { getBiLabsUrl } from '@layers-frontend/commons/store/selectors/user'
import { resolveBiLabsS3Url } from '../../actions/biLabs'
import PowerBI from '../../components/UIComponents/PowerBI'

const mapStateToProps = state => ({
  url: getBiLabsUrl(state),
  title: 'BI Labs'
})

const mapDispatchToProps = {
  resolveS3Url: resolveBiLabsS3Url
}

export default compose(withTranslator, connect(mapStateToProps, mapDispatchToProps))(PowerBI)
